/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-08-14 14:18:22
 * @LastEditors: caiqin.xie
 * @message: 博客列表右侧社交平台
 */
import React from "react";
import styles from "../../index.module.scss";

interface IProps {
  ctry: string;
  words: Record<string, string>;
}

interface ILink {
  id: string;
  href: string;
  icon: string;
  name: string;
}

const Facebook_icon = require('../../assets/Facebook.svg')
const Twitter_icon = require('../../assets/Twitter.svg')
const Instagram_icon = require('../../assets/Instagram.svg')
const Youtube_icon = require('../../assets/Youtube.svg')
const TikTok_icon = require('../../assets/TikTok.png')

const linkList:ILink[]  = [
  { id: '1', href: 'https://www.facebook.com/PICOXR/', icon: Facebook_icon, name: 'common_facebook' },
  { id: '2', href: 'https://twitter.com/PICOXR', icon: Twitter_icon, name: 'common_twitter' },
  { id: '3', href: 'https://www.instagram.com/picoxr/', icon: Instagram_icon, name: 'common_instagram' },
  { id: '4', href: 'https://www.youtube.com/@PICOXR/', icon: Youtube_icon, name: 'common_youtube' },
  { id: '5', href: 'https://www.tiktok.com/@picoxr', icon: TikTok_icon, name: 'common_tikTok' }
]

const SocialPlatform = (props:IProps) => {
  const {ctry, words} = props
  return (
    <div className={styles['blog-right-footer']}>
      <h3>{words?.blog_contact_title}</h3>
      {/* Stay Connected */}
      <ul className={styles['share-link-list']}>
        {linkList.map(link => (
          <li className={styles['share-link-item']} key={link.id}>
            <img src={link.icon} alt={words[link.name]} />
            <a href={link.href} target="_blank">{words[link.name]}</a>
          </li>
        ))}
      </ul>
    </div>
  )
}
export default SocialPlatform